export const ACCESS_RIGHTS = {
  HOME_DASHBOARD: 'HOME_DASHBOARD',
  ACCOUNT: 'ACCOUNT',
  APPLICATIONS: 'APPLICATIONS',
  USERS: 'USERS',
  KNOWLEDGE_CENTER: 'KNOWLEDGE_CENTER',
} as const

export type AccessRightOption = keyof typeof ACCESS_RIGHTS
